<section class="">
  <!-- Form -->
  <form [formGroup]="categoryForm" class="space-y-5">
    <!-- Name Field -->
    <div class="form-group">
      <app-custom-input [label]="'Name'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Type category name here'" formControlName="name"></app-custom-input>
      @if (categoryForm.get('name')?.invalid && (categoryForm.get('name')?.touched || categoryForm.get('name')?.dirty))
      {
      <div class="text-error text-xs mt-2">Name is required.</div>
      }
    </div>

    <!-- Description Field -->
    <div class="form-group">
      <app-custom-input [label]="'Description'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Type description here'" [isTextarea]="true" [rows]="4"
        formControlName="description"></app-custom-input>
      @if (categoryForm.get('description')?.invalid && (categoryForm.get('description')?.touched ||
      categoryForm.get('description')?.dirty)) {
      <div class="text-error text-xs mt-2">Description is required</div>
      }
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-primary-button [text]="category() ? 'Update' : 'Confirm'" [isLoading]="isLoading"
        (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>